import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDesk32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 27,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 8a.5.5 0 0 1 0 1H25l1 11h-1L24 9H14l-1 11h-1l1-11h-1.5a.5.5 0 0 1 0-1h15ZM9 20H8v-6H2v6H1v-6H0v-2.667c0-.62.425-1.143 1-1.291V1.333C1 .597 1.597 0 2.333 0h5.334C8.403 0 9 .597 9 1.333l.001 8.71c.575.148.999.67.999 1.29V14H9v6Zm-.333-9H1.333a.333.333 0 0 0-.326.266L1 11.333V13h8v-1.667a.333.333 0 0 0-.266-.326L8.667 11Zm-1-10H2.333a.333.333 0 0 0-.326.266L2 1.333V10h6V1.333a.333.333 0 0 0-.266-.326L7.667 1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgDesk32;